import React from 'react';
import { Col, Row } from 'react-bootstrap';
import AgentCollectionHistoryComponent from '../Component/AgentCollectionHistoryComponent/AgentCollectionHistoryCoponent';

function CollectionHistory(props) {
    return (
        <>
            <Row>
                <Col md={12}>
                    <AgentCollectionHistoryComponent />
                </Col>
            </Row>
        </>
    );
}

export default CollectionHistory;